export const SEND_PAY_PAL_SUBMIT_ORDER_FAILURE = 'SEND_PAY_PAL_SUBMIT_ORDER_FAILURE';

export const sendPayPalSubmitOrderFailure = (payload: Error) => ({
    type: SEND_PAY_PAL_SUBMIT_ORDER_FAILURE,
    payload,
});
